'use client';

import { useEffect, useState } from 'react';

interface ClientWrapperProps {
    children: React.ReactNode;
    fallback?: React.ReactNode;
}

export function ClientWrapper({ children, fallback }: ClientWrapperProps) {
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);

        // Remove any unwanted attributes that might be added by extensions
        const removeUnwantedAttributes = () => {
            const body = document.body;
            if (body.hasAttribute('data-gptw')) {
                body.removeAttribute('data-gptw');
            }

            // Remove other potential problematic attributes
            const unwantedAttrs = ['data-gptw', 'data-extension'];
            unwantedAttrs.forEach(attr => {
                if (body.hasAttribute(attr)) {
                    body.removeAttribute(attr);
                }
            });
        };

        // Run immediately and also set up a mutation observer
        removeUnwantedAttributes();

        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'attributes') {
                    removeUnwantedAttributes();
                }
            });
        });

        observer.observe(document.body, {
            attributes: true,
            attributeFilter: ['data-gptw', 'data-extension']
        });

        return () => observer.disconnect();
    }, []);

    if (!mounted) {
        return fallback || <div className="min-h-screen bg-background" />;
    }

    return <>{children}</>;
}
